import { Outlet, useMatch } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { SettingsCustomizationsPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import CustomizationSettings from 'modules/settings/components/CustomizationSettings'

const CustomizationsPage = () => {
  const { has_employees_custom_tables: hasEmployeesCustomTables } = useFeatures([
    'employees_custom_tables',
  ])
  const { navigation } = useNavigation()
  const { data } = useQuery(SettingsCustomizationsPageDocument)
  const isCustomizationRoute = useMatch(navigation.settings.customizations.fullPath())

  const canManageCustomization = !!data?.apiCore._policies.companyManageCustomization.can
  const canManageTables =
    hasEmployeesCustomTables && !!data?.employees._policies.manageCustomTableSettings.can

  return (
    <AuthorizeUser authorizeFn={() => canManageCustomization}>
      {isCustomizationRoute ? (
        <ResponsivePage.Body
          variant="narrow"
          header={{
            title: i18n.t('settings.customization.title'),
            backLink: { href: navigation.settings.fullPath(), label: '' },
          }}
        >
          <CustomizationSettings canManageTables={canManageTables} />
        </ResponsivePage.Body>
      ) : (
        <Outlet />
      )}
    </AuthorizeUser>
  )
}

export default CustomizationsPage
